export enum DocumentType {
  PDF
}
